import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'
import { type ResCreateCases } from '@/lib/queries/business/v1/case/types'

export const createCasesMutation = {
  mutationFn: (
    data: {
      applicantName?: string
      applicantEmail?: string
      applicantPhone?: string
      caseNumber?: string
      caseCategory?: string
      applicantTags?: string[]
      caseTags?: string[]
    }[]
  ): Promise<ResCreateCases> =>
    w
      .post(
        data.map((x) => ({
          applicant_email: x.applicantEmail,
          applicant_phone: x.applicantPhone,
          case_number: x.caseNumber,
          path_name: x.caseCategory,
          root_path_name: x.applicantName,
          applicant_tags: x.applicantTags,
          case_tags: x.caseTags,
        })),
        API_ENDPOINTS.business.v1.case.bulk.register.index
      )
      .json(),
}
